import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './Login.css';

export default function Login() {
  const [creds, setCreds] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', creds);
      sessionStorage.setItem('eden_token', res.data.token);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__logo">
          <span className="login-card__logo-text">Eden</span>
          <span className="login-card__logo-sub">Pensiune — Admin</span>
        </div>
        <form onSubmit={handleSubmit} className="login-card__form">
          <div className="form-group">
            <label>Username / Email</label>
            <input
              value={creds.username}
              onChange={e => setCreds(c => ({...c, username: e.target.value}))}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Parolă</label>
            <input
              type="password"
              value={creds.password}
              onChange={e => setCreds(c => ({...c, password: e.target.value}))}
              required
            />
          </div>
          {error && <p className="login-card__error">{error}</p>}
          <button type="submit" className="btn btn-primary login-card__btn" disabled={loading}>
            {loading ? 'Se autentifică...' : 'Autentificare'}
          </button>
        </form>
      </div>
    </div>
  );
}
